import type { RootState } from "@/services/store";

export const selectedLangSelector = (state: RootState) => state.i18n.selectedLang;
